"use strict";

// ====== tab active start

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// ====== tab active end

// ====== Accordion start

function toggleExpanded(element, show) {
  var target = document.getElementById(element.getAttribute("aria-controls"));

  if (target) {
    element.setAttribute("aria-expanded", show);
    target.setAttribute("aria-hidden", !show);
  }
}

/**

  @param {HTMLElement} accordionContainer 
*/
function setupAccordion(accordionContainer) {
  function closeAllPanels() {
    var openPanels = accordionContainer.querySelectorAll(
      "[aria-expanded=true]"
    );

    for (var i = 0, l = openPanels.length; i < l; i++) {
      toggleExpanded(openPanels[i], false);
    }
  }

  accordionContainer.addEventListener("click", function (event) {
    var target = event.target;
    if (target.closest) {
      target = target.closest('[class*="p-accordion__tab"]');
    }
    if (target) {
      var isTargetOpen = target.getAttribute("aria-expanded") === "true";
      closeAllPanels();
      toggleExpanded(target, !isTargetOpen);
    }
  });
}

var accordions = document.querySelectorAll(".p-accordion");

for (var i = 0, l = accordions.length; i < l; i++) {
  setupAccordion(accordions[i]);
}

// ====== Accordion end

// ====== Hotspot Active start

const selectHotspot = (e) => {
  const clickedHotspot = e.target.parentElement;
  const container = clickedHotspot.parentElement;
  const hotspots = container.querySelectorAll(".lg-hotspot");
  hotspots.forEach((hotspot) => {
    if (hotspot === clickedHotspot) {
      hotspot.classList.toggle("lg-hotspot--selected");
    } else {
      hotspot.classList.remove("lg-hotspot--selected");
    }
  });
};

(() => {
  const buttons = document.querySelectorAll(".lg-hotspot__button");
  buttons.forEach((button) => {
    button.addEventListener("click", selectHotspot);
  });
})();

// ====== Hotspot Active end

// ====== Navbar toggler start

const mobilemenuToggle = document.querySelector(".demoheader__mobile-menu");
const mobileMenu = document.querySelector(".mobile-menu");
const mobileMenuOverlay = document.querySelector(".mobilemenu-overlay");
const mobilemenuCloseBtn = document.querySelector(".btn-mobilemenu-close");

mobilemenuToggle.addEventListener("click", () => {
  mobileMenu.classList.toggle("active");
});

mobileMenuOverlay.addEventListener("click", () => {
  mobileMenu.classList.toggle("active");
});
mobilemenuCloseBtn.addEventListener("click", () => {
  mobileMenu.classList.remove("active");
});

/* Collapsible Mobile Menu */ 
const mobileDropdownBtns = document.querySelectorAll("li.dropdown > a");
const mobileDropdownPopups = document.querySelectorAll("li.dropdown > ul");

mobileDropdownBtns.forEach((btn, index) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();

    btn.classList.toggle("collapse");

    const dropdownMenu = mobileDropdownPopups[index];

    // Toggle active class on the dropdown menu
    dropdownMenu.classList.toggle("active");

    // If active, set max-height to the actual height of the content
    if (dropdownMenu.classList.contains("active")) {
      dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + "px";
    } else {
      // If not active, set max-height back to 0px
      dropdownMenu.style.maxHeight = "0px";
    }
  });
});

// ====== Navbar toggler end


// video popup
window.document.onkeydown = function (e) {
  if (!e) {
    e = event;
  }
  if (e.keyCode == 27) {
    lightbox_close();
  }
};

function lightbox_open() {
  var lightBoxVideo = document.getElementById("VisaChipCardVideo");
  window.scrollTo(0, 0);
  document.getElementById("light").style.display = "block";
  document.getElementById("fade").style.display = "block";
  lightBoxVideo.play();
}

function lightbox_close() {
  var lightBoxVideo = document.getElementById("VisaChipCardVideo");
  document.getElementById("light").style.display = "none";
  document.getElementById("fade").style.display = "none";
  lightBoxVideo.pause();
}
// video popup

function incrementValue() {
  var value = parseInt(document.getElementById("number").value, 10);
  value = isNaN(value) ? 0 : value;
  if (value < 70) {
    value++;
    document.getElementById("number").value = value;
  }
}
function decrementValue() {
  var value = parseInt(document.getElementById("number").value, 10);
  value = isNaN(value) ? 0 : value;
  if (value > 1) {
    value--;
    document.getElementById("number").value = value;
  }
}

function incrementValue2() {
  var value = parseInt(document.getElementById("number2").value, 10);
  value = isNaN(value) ? 0 : value;
  if (value < 80) {
    value++;
    document.getElementById("number2").value = value;
  }
}
function decrementValue2() {
  var value = parseInt(document.getElementById("number2").value, 10);
  value = isNaN(value) ? 0 : value;
  if (value > 1) {
    value--;
    document.getElementById("number2").value = value;
  }
}

/*!
 * Flickity fullscreen v1.1.1
 * Enable fullscreen view for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if (typeof define == "function" && define.amd) {
    // AMD
    define(["flickity/js/index"], factory);
  } else if (typeof module == "object" && module.exports) {
    // CommonJS
    module.exports = factory(require("flickity"));
  } else {
    // browser global
    factory(window.Flickity);
  }
})(window, function factory(Flickity) {
  "use strict";

  Flickity.createMethods.push("_createFullscreen");
  var proto = Flickity.prototype;

  proto._createFullscreen = function () {
    this.isFullscreen = false;

    if (!this.options.fullscreen) {
      return;
    }
    // buttons
    this.viewFullscreenButton = new FullscreenButton("view", this);
    this.exitFullscreenButton = new FullscreenButton("exit", this);

    this.on("activate", this._changeFullscreenActive);
    this.on("deactivate", this._changeFullscreenActive);
  };

  // ----- activation ----- //

  proto._changeFullscreenActive = function () {
    var childMethod = this.isActive ? "appendChild" : "removeChild";
    this.element[childMethod](this.viewFullscreenButton.element);
    this.element[childMethod](this.exitFullscreenButton.element);
    // activate or deactivate buttons
    var activeMethod = this.isActive ? "activate" : "deactivate";
    this.viewFullscreenButton[activeMethod]();
    this.exitFullscreenButton[activeMethod]();
  };

  // ----- view, exit, toggle ----- //

  proto.viewFullscreen = function () {
    this._changeFullscreen(true);
    this.focus();
  };

  proto.exitFullscreen = function () {
    this._changeFullscreen(false);
  };

  proto._changeFullscreen = function (isView) {
    if (this.isFullscreen == isView) {
      return;
    }
    this.isFullscreen = isView;
    var classMethod = isView ? "add" : "remove";
    document.documentElement.classList[classMethod]("is-flickity-fullscreen");
    this.element.classList[classMethod]("is-fullscreen");
    this.resize();
    // HACK extra reposition on fullscreen for images
    if (this.isFullscreen) {
      this.reposition();
    }
    this.dispatchEvent("fullscreenChange", null, [isView]);
  };

  proto.toggleFullscreen = function () {
    this._changeFullscreen(!this.isFullscreen);
  };

  // ----- setGallerySize ----- //

  // overwrite so fullscreen cells are full height
  var setGallerySize = proto.setGallerySize;
  proto.setGallerySize = function () {
    if (!this.options.setGallerySize) {
      return;
    }
    if (this.isFullscreen) {
      // remove height style on fullscreen
      this.viewport.style.height = "";
    } else {
      // otherwise, do normal
      setGallerySize.call(this);
    }
  };

  // ----- keyboard ----- //

  // ESC key closes full screen
  Flickity.keyboardHandlers[27] = function () {
    this.exitFullscreen();
  };

  // ----- FullscreenButton ----- //

  function FullscreenButton(name, flickity) {
    this.name = name;
    this.createButton();
    this.createIcon();
    // events
    // trigger viewFullscreen or exitFullscreen on click
    this.onClick = function () {
      flickity[name + "Fullscreen"]();
    };
    this.clickHandler = this.onClick.bind(this);
  }

  FullscreenButton.prototype.createButton = function () {
    var element = (this.element = document.createElement("button"));
    element.className =
      "flickity-button flickity-fullscreen-button " +
      "flickity-fullscreen-button-" +
      this.name;
    // prevent button from submitting form
    element.setAttribute("type", "button");
    // set label
    var label = capitalize(this.name + " full-screen");
    element.setAttribute("aria-label", label);
    element.title = label;
  };

  function capitalize(text) {
    return text[0].toUpperCase() + text.slice(1);
  }

  var svgURI = "http://www.w3.org/2000/svg";

  var pathDirections = {
    view: "M15,20,7,28h5v4H0V20H4v5l8-8Zm5-5,8-8v5h4V0H20V4h5l-8,8Z",
    exit: "M32,3l-7,7h5v4H18V2h4V7l7-7ZM3,32l7-7v5h4V18H2v4H7L0,29Z",
  };

  FullscreenButton.prototype.createIcon = function () {
    var svg = document.createElementNS(svgURI, "svg");
    svg.setAttribute("class", "flickity-button-icon");
    svg.setAttribute("viewBox", "0 0 32 32");
    // path & direction
    var path = document.createElementNS(svgURI, "path");
    var direction = pathDirections[this.name];
    path.setAttribute("d", direction);
    // put it together
    svg.appendChild(path);
    this.element.appendChild(svg);
  };

  FullscreenButton.prototype.activate = function () {
    this.element.addEventListener("click", this.clickHandler);
  };

  FullscreenButton.prototype.deactivate = function () {
    this.element.removeEventListener("click", this.clickHandler);
  };

  Flickity.FullscreenButton = FullscreenButton;

  // ----- fin ----- //

  return Flickity;
});

/**
 * Flickity fade v1.0.0
 * Fade between Flickity slides
 */

/* jshint browser: true, undef: true, unused: true */

(function (window, factory) {
  // universal module definition
  /*globals define, module, require */
  if (typeof define == "function" && define.amd) {
    // AMD
    define(["flickity/js/index", "fizzy-ui-utils/utils"], factory);
  } else if (typeof module == "object" && module.exports) {
    // CommonJS
    module.exports = factory(require("flickity"), require("fizzy-ui-utils"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(this, function factory(Flickity, utils) {
  // ---- Slide ---- //

  var Slide = Flickity.Slide;

  var slideUpdateTarget = Slide.prototype.updateTarget;
  Slide.prototype.updateTarget = function () {
    slideUpdateTarget.apply(this, arguments);
    if (!this.parent.options.fade) {
      return;
    }
    // position cells at selected target
    var slideTargetX = this.target - this.x;
    var firstCellX = this.cells[0].x;
    this.cells.forEach(function (cell) {
      var targetX = cell.x - firstCellX - slideTargetX;
      cell.renderPosition(targetX);
    });
  };

  Slide.prototype.setOpacity = function (alpha) {
    this.cells.forEach(function (cell) {
      cell.element.style.opacity = alpha;
    });
  };

  // ---- Flickity ---- //

  var proto = Flickity.prototype;

  Flickity.createMethods.push("_createFade");

  proto._createFade = function () {
    this.fadeIndex = this.selectedIndex;
    this.prevSelectedIndex = this.selectedIndex;
    this.on("select", this.onSelectFade);
    this.on("dragEnd", this.onDragEndFade);
    this.on("settle", this.onSettleFade);
    this.on("activate", this.onActivateFade);
    this.on("deactivate", this.onDeactivateFade);
  };

  var updateSlides = proto.updateSlides;
  proto.updateSlides = function () {
    updateSlides.apply(this, arguments);
    if (!this.options.fade) {
      return;
    }
    // set initial opacity
    this.slides.forEach(function (slide, i) {
      var alpha = i == this.selectedIndex ? 1 : 0;
      slide.setOpacity(alpha);
    }, this);
  };

  /* ---- events ---- */

  proto.onSelectFade = function () {
    // in case of resize, keep fadeIndex within current count
    this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
    this.prevSelectedIndex = this.selectedIndex;
  };

  proto.onSettleFade = function () {
    delete this.didDragEnd;
    if (!this.options.fade) {
      return;
    }
    // set full and 0 opacity on selected & faded slides
    this.selectedSlide.setOpacity(1);
    var fadedSlide = this.slides[this.fadeIndex];
    if (fadedSlide && this.fadeIndex != this.selectedIndex) {
      this.slides[this.fadeIndex].setOpacity(0);
    }
  };

  proto.onDragEndFade = function () {
    // set flag
    this.didDragEnd = true;
  };

  proto.onActivateFade = function () {
    if (this.options.fade) {
      this.element.classList.add("is-fade");
    }
  };

  proto.onDeactivateFade = function () {
    if (!this.options.fade) {
      return;
    }
    this.element.classList.remove("is-fade");
    // reset opacity
    this.slides.forEach(function (slide) {
      slide.setOpacity("");
    });
  };

  /* ---- position & fading ---- */

  var positionSlider = proto.positionSlider;
  proto.positionSlider = function () {
    if (!this.options.fade) {
      positionSlider.apply(this, arguments);
      return;
    }

    this.fadeSlides();
    this.dispatchScrollEvent();
  };

  var positionSliderAtSelected = proto.positionSliderAtSelected;
  proto.positionSliderAtSelected = function () {
    if (this.options.fade) {
      // position fade slider at origin
      this.setTranslateX(0);
    }
    positionSliderAtSelected.apply(this, arguments);
  };

  proto.fadeSlides = function () {
    if (this.slides.length < 2) {
      return;
    }
    // get slides to fade-in & fade-out
    var indexes = this.getFadeIndexes();
    var fadeSlideA = this.slides[indexes.a];
    var fadeSlideB = this.slides[indexes.b];
    var distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
    var progress = this.wrapDifference(fadeSlideA.target, -this.x);
    progress = progress / distance;

    fadeSlideA.setOpacity(1 - progress);
    fadeSlideB.setOpacity(progress);

    // hide previous slide
    var fadeHideIndex = indexes.a;
    if (this.isDragging) {
      fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
    }
    var isNewHideIndex =
      this.fadeHideIndex != undefined &&
      this.fadeHideIndex != fadeHideIndex &&
      this.fadeHideIndex != indexes.a &&
      this.fadeHideIndex != indexes.b;
    if (isNewHideIndex) {
      // new fadeHideSlide set, hide previous
      this.slides[this.fadeHideIndex].setOpacity(0);
    }
    this.fadeHideIndex = fadeHideIndex;
  };

  proto.getFadeIndexes = function () {
    if (!this.isDragging && !this.didDragEnd) {
      return {
        a: this.fadeIndex,
        b: this.selectedIndex,
      };
    }
    if (this.options.wrapAround) {
      return this.getFadeDragWrapIndexes();
    } else {
      return this.getFadeDragLimitIndexes();
    }
  };

  proto.getFadeDragWrapIndexes = function () {
    var distances = this.slides.map(function (slide, i) {
      return this.getSlideDistance(-this.x, i);
    }, this);
    var absDistances = distances.map(function (distance) {
      return Math.abs(distance);
    });
    var minDistance = Math.min.apply(Math, absDistances);
    var closestIndex = absDistances.indexOf(minDistance);
    var distance = distances[closestIndex];
    var len = this.slides.length;

    var delta = distance >= 0 ? 1 : -1;
    return {
      a: closestIndex,
      b: utils.modulo(closestIndex + delta, len),
    };
  };

  proto.getFadeDragLimitIndexes = function () {
    // calculate closest previous slide
    var dragIndex = 0;
    for (var i = 0; i < this.slides.length - 1; i++) {
      var slide = this.slides[i];
      if (-this.x < slide.target) {
        break;
      }
      dragIndex = i;
    }
    return {
      a: dragIndex,
      b: dragIndex + 1,
    };
  };

  proto.wrapDifference = function (a, b) {
    var diff = b - a;

    if (!this.options.wrapAround) {
      return diff;
    }

    var diffPlus = diff + this.slideableWidth;
    var diffMinus = diff - this.slideableWidth;
    if (Math.abs(diffPlus) < Math.abs(diff)) {
      diff = diffPlus;
    }
    if (Math.abs(diffMinus) < Math.abs(diff)) {
      diff = diffMinus;
    }
    return diff;
  };

  // ---- wrapAround ---- //

  var _getWrapShiftCells = proto._getWrapShiftCells;
  proto._getWrapShiftCells = function () {
    if (!this.options.fade) {
      _getWrapShiftCells.apply(this, arguments);
    }
  };

  var shiftWrapCells = proto.shiftWrapCells;
  proto.shiftWrapCells = function () {
    if (!this.options.fade) {
      shiftWrapCells.apply(this, arguments);
    }
  };

  return Flickity;
});
